var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCourseLearnersIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_873_12192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6065 13.7735L11.6065 12.4905C11.6065 11.81 11.3362 11.1573 10.855 10.6761C10.3737 10.1948 9.72107 9.9245 9.04053 9.9245L3.90853 9.9245C3.22798 9.9245 2.57531 10.1948 2.09409 10.6761C1.61287 11.1573 1.34253 11.81 1.34253 12.4905L1.34253 13.7735",
    stroke: "#817D7D",
    strokeWidth: 1.283,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.47469 7.3585C7.89185 7.3585 9.04069 6.20966 9.04069 4.7925C9.04069 3.37534 7.89185 2.2265 6.47469 2.2265C5.05753 2.2265 3.90869 3.37534 3.90869 4.7925C3.90869 6.20966 5.05753 7.3585 6.47469 7.3585Z",
    stroke: "#817D7D",
    strokeWidth: 1.283,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4557 13.7735L15.4557 12.4905C15.4553 11.9219 15.2661 11.3696 14.9178 10.9203C14.5694 10.4709 14.0817 10.15 13.5312 10.0079",
    stroke: "#817D7D",
    strokeWidth: 1.283,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9651 2.30988C11.517 2.4512 12.0063 2.77221 12.3556 3.22229C12.705 3.67237 12.8946 4.22593 12.8946 4.79569C12.8946 5.36545 12.705 5.919 12.3556 6.36909C12.0063 6.81917 11.517 7.14018 10.9651 7.2815",
    stroke: "#817D7D",
    strokeWidth: 1.283,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_873_12192"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.396,
    height: 15.396,
    fill: "white",
    transform: "translate(0.701172 0.302002)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseLearnersIc);
export default __webpack_public_path__ + "static/media/course_learners_ic.3bb267768a46dab67d13b9f818c84996.svg";
export { ForwardRef as ReactComponent };